import(/* webpackMode: "eager", webpackExports: ["SponsorsSection"] */ "/app/apps/tournament/src/tournament/components/details/SponsorsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerList"] */ "/app/apps/tournament/src/tournament/components/players/PlayerList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/advertisements/components/advertisement-wrapper.tsx");
